<template>
  <Teleport to="body">
    <!-- WIDGET WRAPPER-->
    <div class="chat-widget-wrapper" :class="{'minimized': minimized}" :style="getStyle" style="transition: width .2s cubic-bezier(0.165,0.84,0.44,1), height .2s cubic-bezier(0.165,0.84,0.44,1);
    -webkit-transition: width .2s cubic-bezier(0.165,0.84,0.44,1), height .2s cubic-bezier(0.165,0.84,0.44,1)">
      <div class="chat-widget-header" @mousedown.left="startDrag" style="z-index: 2" @dblclick="maximize">
        <div class="text">
          <span class="user-name">{{name}}</span>
          <a href="#" class="order-number" @click="openOrder">#{{order_id}}</a>
        </div>
        <div class="action-btns">
          <button class="minimize-chat" @click="minimized = true">
            <span class="icon icon-minimize"></span>
          </button>
          <button style="display: none;">
            <span class="icon icon-full"></span>
          </button>
          <button class="close-chat" @click="close">
            <span class="icon icon-cross"></span>
          </button>
        </div>
      </div>
      <iframe src="http://localhost:6040/static/widget/" frameborder="0" width="100%"></iframe>
      <div :class="{'minimized': minimized}" class="overlay" @click="minimized = false"></div>
    </div>
    <!--END WIDGET WRAPPER-->
  </Teleport>
</template>

<script>
  import api from '@/api'

  export default {
    name    : 'ChatWidget',
    props   : ['name', 'order_id', 'chat_id', 'startX', 'startY', 'idx'],
    emits:['closeChat'],
    data() {
      return {
        x        : 0,
        y        : 0,
        offsetX  : 0,
        offsetY  : 0,
        grabbing : false,
        minimized: false
      }
    },
    computed: {
      getStyle() {
        return {
          left  : this.x + 'px',
          top   : this.y + 'px',
          cursor: this.grabbing ? 'grabbing' : 'pointer'
        }
      }
    },
    methods : {
      startDrag(event) {
        event.preventDefault();
        event.stopPropagation();
        this.grabbing = true;

        this.offsetX = event.clientX - this.x;
        this.offsetY = event.clientY - this.y;

        document.addEventListener('mousemove', this.mouseMove);
        document.addEventListener('mouseup', this.endDrag);
      },
      openOrder() {
        // console.log('start open order');

        api.post('/api/order/filter', {id: this.order_id}).then(response => response.data).then(
          data => {
            data.created_at = new Date(data.created_at);
            data.updated_at = new Date(data.updated_at);
            // console.log('order', data);
            return data
          })
          .then(order => {
            window.openOrder(order)
          })
      },
      mouseMove(event) {
        event.preventDefault();
        event.stopPropagation();

        this.x = event.clientX - this.offsetX;
        this.y = event.clientY - this.offsetY;
      },
      endDrag(event) {
        event.preventDefault();
        event.stopPropagation();

        this.grabbing = false;

        document.removeEventListener('mousemove', this.mouseMove);
        document.removeEventListener('mouseup', this.endDrag);
      },
      close() {
        this.$emit('closeChat', this.idx);
      },
      maximize() {
        this.minimized = !this.minimized;
      }
    }
  }
</script>

<style scoped>
  .overlay {position : absolute;
    left             : 0;
    top              : 0;
    height           : 100%;
    width            : 100%;
    z-index          : -1;
  }

  .overlay.minimized {
    z-index : 1;
  }
</style>